<template>
  <div>
    <nav class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'reports'}">Reports</router-link>
          </div>
          <div class="text-xl text-primary capitalize">
            {{ reports[report] || report }}
          </div>
        </div>
        <div class="">

          <div class="md:flex">
            <div class="inline-block relative float-right mr-3" @click="showModals">
              <div :class="myReports.length === 0 ? 'bg-red-500 hover:bg-red-700':'bg-teal-500 hover:bg-teal-700'"
                   class=" text-white  py-2 px-4 rounded-lg inline-flex items-center">
                <feather v-if="myReports.length !== 0" type="check-circle" size="20" class=""></feather>
                <feather v-else type="bell" size="20" class=""></feather>
              </div>
            </div>

            <div class="">
              <multiselect v-model="filters.venues" placeholder="Networks" :multiple="true"
                           track-by="id" :options="venues" label="name"
                           :taggable="true"></multiselect>
            </div>
            <div class="md:ml-2 mt-2 md:mt-0" style="z-index: 0">
              <date-range-picker
                  ref="dateRange"
                  v-model="filters.dateRange"
                  :opens="picker.opens"
                  :locale-data="picker.locale"
                  :minDate="picker.minDate"
                  :maxDate="picker.maxDate"
                  :singleDatePicker="picker.singleDatePicker"
                  :timePicker="picker.timePicker"
                  :timePicker24Hour="picker.timePicker24Hour"
                  :showWeekNumbers="picker.showWeekNumbers"
                  :showDropdowns="picker.showDropdowns"
                  :autoApply="picker.autoApply"
                  :linkedCalendars="picker.linkedCalendars"
                  :dateFormat="picker.dateFormat">
              </date-range-picker>
            </div>

          </div>
        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div v-if="report === 'overview'">
        <OverviewReport :configs="configs"/>
        <ConnectionModeOverviewReport class="mt-4" :configs="configs"/>
      </div>
      <NewVisitorsReport v-if="report === 'new_visitors'" :configs="configs"/>
      <UniqueVisitorsReport v-if="report === 'all_visitors'" :configs="configs"/>
      <RepeatVisitorsReport v-else-if="report === 'repeat_visitors'" :configs="configs"/>
    </div>
  </div>
</template>

<script>

import GraphQl from "../../services/graphql.service";

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
import UniqueVisitorsReport from "@/modules/reports/UniqueVisitorsReport";
import RepeatVisitorsReport from "@/modules/reports/RepeatVisitorsReport";
import NewVisitorsReport from "@/modules/reports/NewVisitorsReport";
import OverviewReport from "@/modules/reports/OverviewReport";
import ConnectionModeOverviewReport from "@/modules/reports/ConnectionModeOverviewReport";

export default {
  name: "ReportsComponents",
  components: {
    ConnectionModeOverviewReport,
    OverviewReport, NewVisitorsReport, RepeatVisitorsReport, UniqueVisitorsReport, DateRangePicker
  },
  data() {
    return {
      reports: {
        'overview': 'Organization Overview Report',
        'new_visitors': 'First Time Visitors',
        'unique_visitors': 'Unique Visitors',
        'all_visitors': 'All Visitors',
        'repeat_visitors': 'Repeat Visitors',
        'footfall': 'Footfall',
      },
      filters: {
        dateRange: {
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day")
        },
        venues: [],
        myReports: [],
      },
      picker: {
        opens: "left",
        timePicker: false,
        autoApply: false,
        linkedCalendars: true,
        maxDate: moment(moment.now()).format("YYYY-MM-DD"),
        locale: {
          format: 'dd/mm/yyyy',
          direction: "ltr", //direction of text format: "DD-MM-YYYY", //format of the dates displayed
          separator: " - ", //separator between the two ranges
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
          monthNames: moment.monthsShort(), //array of month names - see moment documentions for details
          firstDay: 1 //ISO first day of week - see moment documenations for details
        }

      },
      venues: [],
      myReports: []
    }
  },
  props: {
    report: {type: String, default: 'Reports'},
  },
  mounted() {
    GraphQl.sendRequest("{venues{id name}}")
        .then(response => {
              this.venues = response.venues;
            }
        )
    this.getReport();
  },
  computed: {
    venueIds() {
      let v = [];
      this.filters.venues.forEach(function (venue) {
        v.push(venue.id);
      });
      return v;
    },
    startDate() {
      return moment(this.filters.dateRange.startDate).format("YYYY-MM-DD")
    },
    endDate() {
      return moment(this.filters.dateRange.endDate).format("YYYY-MM-DD")
    },
    configs() {
      return {
        venues: this.venueIds,
        startDate: this.startDate,
        endDate: this.endDate
      }
    }
  },
  watch: {
    report: function () {
      this.getReport();
    },
  },
  methods: {
    getReport() {
      GraphQl.sendRequest('{myReports(report:"' + this.report + '" ){id report send_at}}')
          .then(response => {
                this.myReports = response.myReports;
              }
          )
    },
    showModals() {
      this.$root.$emit("show_modal", {report: this.report, reportName: this.reports[this.report], modal: 'subscribe'});
    },
  }
}
</script>

<style scoped>

</style>